import type { PlayerStats } from './player-stats';

export type Badge = {
  id: string;
  label: string;
  icon: string;
  description: string;
  tier: 'bronze' | 'silver' | 'gold';
};

export function computeBadges(
  stats: PlayerStats,
  sessions: { net: number; buyIns: number }[]
): Badge[] {
  const badges: Badge[] = [];

  if (stats.currentStreak >= 3 && stats.streakType === 'win')
    badges.push({ id: 'hot-streak', label: 'Hot Streak', icon: 'Flame', description: '3+ wins in a row', tier: 'silver' });

  if (stats.currentStreak >= 5 && stats.streakType === 'win')
    badges.push({ id: 'on-fire', label: 'On Fire', icon: 'Zap', description: '5+ wins in a row', tier: 'gold' });

  if (stats.totalSessions >= 10)
    badges.push({ id: 'iron-man', label: 'Iron Man', icon: 'Shield', description: '10+ sessions played', tier: 'bronze' });

  if (stats.totalSessions >= 25)
    badges.push({ id: 'centurion', label: 'Centurion', icon: 'Trophy', description: '25+ sessions played', tier: 'gold' });

  if (stats.maxWin >= 200)
    badges.push({ id: 'big-stack', label: 'Big Stack', icon: 'DollarSign', description: 'Won 200+ in a single session', tier: 'silver' });

  if (stats.totalNet >= 500)
    badges.push({ id: 'whale', label: 'Whale', icon: 'Star', description: 'Lifetime net ≥ 500', tier: 'gold' });

  if (stats.winRate >= 60 && stats.totalSessions >= 8)
    badges.push({ id: 'consistent', label: 'Consistent', icon: 'BarChart2', description: '60%+ win rate over 8+ sessions', tier: 'silver' });

  if (stats.avgBuyIns <= 1.2 && stats.totalSessions >= 5)
    badges.push({ id: 'tight', label: 'Tight Player', icon: 'Target', description: 'Rarely rebuys', tier: 'bronze' });

  if (stats.maxWin >= 300)
    badges.push({ id: 'whale-hunter', label: 'Whale Hunter', icon: 'Anchor', description: 'Biggest single session win ≥ 300', tier: 'gold' });

  return badges;
}
